import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { pxToRem } from 'utils/styled'

export const SContactNotificationModal = styled.div`
  display: flex;
  flex-direction: column;
`

export const SButton = styled(Button)`
  min-width: min(${pxToRem(170)}rem, 100%);
  margin: 2rem auto 0;
`

export const SContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & > svg {
    width: 3rem;
    height: 3rem;
  }
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`

export const SBoundAvatarsContainer = styled.div`
  width: ${pxToRem(200)}rem;
  height: ${pxToRem(140)}rem;
  position: relative;
  & > * {
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0.5rem;
    &:last-of-type {
      left: auto;
      right: 0.5rem;
    }
  }
  & > svg {
    width: 2rem;
    height: 2rem;
    top: 0;
    right: 5px;
  }
`

export const SUnboundAvatarsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & svg {
    margin: 0 1rem;
  }
`
